import * as React from 'react'

import { Tag } from '@enechain/ecloud-designsystem'

const methodColors: Record<string, { color: string; backgroundColor: string }> =
  {
    GET: {
      color: 'Text.positiveMid',
      backgroundColor: 'Surface.positiveMid',
    },
    POST: {
      color: 'Text.accentPrimary',
      backgroundColor: 'Surface.accentPrimaryLightMid',
    },
    PUT: {
      color: 'Text.warningMid',
      backgroundColor: 'Surface.warningMid',
    },
    DELETE: {
      color: 'Text.negativeMid',
      backgroundColor: 'Surface.negativeMid',
    },
  }

const fallbackColors = {
  color: 'Text.neutralHigh',
  backgroundColor: 'Surface.neutralMid',
}

type Props = {
  method: string
}

export const MethodBadge: React.FC<Props> = ({ method }) => {
  const { color, backgroundColor } = methodColors[method] ?? fallbackColors
  return (
    <Tag
      color={color}
      backgroundColor={backgroundColor}
      textStyle="textCaption"
      fontWeight="bold"
      width="54px"
      minHeight="auto"
      justifyContent="center"
      paddingX="3"
      paddingY="2"
    >
      {method}
    </Tag>
  )
}
